// Lucide icon: chevron-right (https://lucide.dev/icons/chevron-right)
import { ChevronRight } from 'lucide-react'

import { IconComponentStyled } from '../styles/IconComponentStyled'
import { type IIconComponentProps } from '../types'

export const IconChevronRight = (props: IIconComponentProps) => {
  return (
    <IconComponentStyled {...props}>
      <ChevronRight />
    </IconComponentStyled>
  )
}
